import PaymentItem from './PaymentItem.jsx'

export default PaymentItem;
